import $ from "jquery";

import {Feature} from "ol";
import {LineString, Point} from "ol/geom";
import {Vector as VectorLayer, Tile as TileLayer} from "ol/layer";
import {Vector as VectorSource, TileWMS, WMTS} from "ol/source";
import {Select} from "ol/interaction";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import {transform} from "ol/proj";
import * as olStyle from "ol/style";
import WKT from "ol/format/WKT";
import GeoJSON from "ol/format/GeoJSON";
import {getTopLeft} from "ol/extent";
import {click as conditionClick} from "ol/events/condition";
//import { Style as Stroke, Fill, Circle } from "ol/style";

export default class SisLayer {
    constructor(map) {
        if (!map) {
            alert("map 값을 설정하여 주세요");
            return false;
        }

        this.props = {};

        this.map = map;
        this.wfs = {
            selectLayer: new VectorLayer({
                name: "selectLayer",
                id: "selectLayer",
                source: new VectorSource(),
                style: new olStyle.Style({
                    image: new olStyle.Circle({
                        radius: 6,
                        stroke: new olStyle.Stroke({
                            color: "rgba(255,0,0,1)",
                            width: 2,
                        }),
                        fill: new olStyle.Fill({
                            color: "rgba(255,0,0,1)",
                        }),
                    }),
                    stroke: new olStyle.Stroke({
                        width: 2,
                        color: "rgba(255,0,0,1)",
                    }),
                    fill: new olStyle.Fill({
                        width: 2,
                        color: "rgba(255, 255, 255, 0)",
                    }),
                }),
                zIndex: 999,
            }),

            searchLayer: new VectorLayer({
                name: "searchLayer",
                id: "searchLayer",
                source: new VectorSource(),
                style: new olStyle.Style({
                    image: new olStyle.Circle({
                        radius: 6,
                        stroke: new olStyle.Stroke({
                            color: "rgba(255,0,0,1)",
                            width: 2,
                        }),
                        fill: new olStyle.Fill({
                            color: "rgba(255,0,0,1)",
                        }),
                    }),
                    stroke: new olStyle.Stroke({
                        width: 2,
                        color: "rgba(0,0,200,1)",
                    }),
                    fill: new olStyle.Fill({
                        width: 2,
                        color: "rgba(0, 0, 0, 0)",
                    }),
                }),
                zIndex: 999,
            }),

            myMapLayer: new VectorLayer({
                name: "myMapLayer",
                id: "myMapLayer",
                source: new VectorSource(),
                style: new olStyle.Style({
                    image: new olStyle.Circle({
                        radius: 6,
                        stroke: new olStyle.Stroke({
                            color: "rgba(255,0,0,1)",
                            width: 2,
                        }),
                        fill: new olStyle.Fill({
                            color: "rgba(255,0,0,1)",
                        }),
                    }),
                    stroke: new olStyle.Stroke({
                        width: 2,
                        color: "rgba(0,0,200,1)",
                    }),
                    fill: new olStyle.Fill({
                        width: 2,
                        color: "rgba(0, 0, 0, 0)",
                    }),
                }),
                zIndex: 998,
            }),

            myMapSelectLayer: new VectorLayer({
                name: "myMapLayer",
                id: "myMapLayer",
                source: new VectorSource(),
                style: new olStyle.Style({
                    stroke: new olStyle.Stroke({
                        width: 2,
                        color: "rgba(255,0,0,1)",
                    }),
                    fill: new olStyle.Fill({
                        width: 2,
                        color: "rgba(0, 0, 0, 0)",
                    }),
                }),
                zIndex: 998,
            }),

            roadviewLayer: new VectorLayer({
                name: "roadviewLayer",
                id: "roadviewLayer",
                source: new VectorSource(),
                zIndex: 999,
            }),

            myPosLayer: new VectorLayer({
                name: "myPosLayer",
                id: "myPosLayer",
                source: new VectorSource(),
            }),
        };
        this.wms = {
            searchLayer: new TileLayer({
                id: "wmsSearchLayer",
                source: new TileWMS({
                    projection: this.map.getView().getProjection().getCode(),
                    url: "/map/proxy/wms.do",
                    params: {
                        LAYERS: "",
                        VERSION: "1.1.0",
                        FORMAT: "image/png",
                        TRANSPARENT: true,
                        TILED : true,
                        //						CQL_FILTER : filter
                    },
                    serverType: "geoserver",
                }),
            }),
        };
        this.wmts = {};

        this.select = null;

        this._init();
        window.sisLayer = this;
    }

    clear = () => {
        this.wfs.selectLayer.getSource().clear();
        this.wfs.searchLayer.getSource().clear();
        // this.wfs.myMapLayer.getSource().clear();
        // this.wfs.myMapSelectLayer.getSource().clear();

        this.stopWmsProperty();
    };

    _init = () => {
        this.map.addLayer(this.wfs.selectLayer);
        this.map.addLayer(this.wfs.searchLayer);
        this.map.addLayer(this.wfs.myMapLayer);
        this.map.addLayer(this.wfs.myMapSelectLayer);
        this.map.addLayer(this.wfs.myPosLayer);

        this.select = new Select({
            condition: conditionClick,
            layers: [this.wfs.selectLayer],
        });
    };

    //WMS 레이어 추가
    addWmsLayer = (layerName, params, strList) => {
        var self = this;
        var visible, zIndex;
        var lyr;

        if (!params.load) return false;
        // console.log(layerName + " :: " + params.load);
        visible = params.visibility;
        // opacity = params.opacity;
        zIndex = params.zindex ? params.zindex : 1;
        // filter = null;

        this.wms[layerName] = new TileLayer({
            kind: params.type,
            title: layerName,
            id: layerName,
            source: new TileWMS({
                projection: self.crsCode,
                url: "/map/proxy/wms.do",
                params: {
                    LAYERS: layerName,
                    VERSION: "1.1.0",
                    FORMAT: "image/png",
                    TRANSPARENT: true,
                    TILED : true,
                    //						CQL_FILTER : filter
                },
                serverType: "geoserver",
            }),
            visible: visible,
            zIndex: zIndex,
            minResolution: this._getResolution(layerName === 'lsmd_cont_ldreg' ? (params.maxZoom + 1) : params.maxZoom),
            maxResolution: this._getResolution(params.minZoom),
            opacity: params.opacity,
        });

        this.map.addLayer(this.wms[layerName]);

        return lyr;
    };

    //WMTS 레이어 추가
    addWmtsLayer = (layerName, params) => {
        // var self = this;

        if (!params.load) return false;

        let projection;
        let resolutions;
        let extent;
        var matrixIds;

        // console.log(params);

        if (params.crsCode === "EPSG:3857" || params.crsCode === "EPSG:900913") {
            projection = "EPSG:900913";
            projection = [
                "EPSG:900913:0",
                "EPSG:900913:1",
                "EPSG:900913:2",
                "EPSG:900913:3",
                "EPSG:900913:4",
                "EPSG:900913:5",
                "EPSG:900913:6",
                "EPSG:900913:7",
                "EPSG:900913:8",
                "EPSG:900913:9",
                "EPSG:900913:10",
                "EPSG:900913:11",
                "EPSG:900913:12",
                "EPSG:900913:13",
                "EPSG:900913:14",
                "EPSG:900913:15",
                "EPSG:900913:16",
                "EPSG:900913:17",
                "EPSG:900913:18",
                "EPSG:900913:19",
                "EPSG:900913:20",
                "EPSG:900913:21",
                "EPSG:900913:22",
                "EPSG:900913:23",
                "EPSG:900913:24",
                "EPSG:900913:25",
                "EPSG:900913:26",
                "EPSG:900913:27",
                "EPSG:900913:28",
                "EPSG:900913:29",
                "EPSG:900913:30",
            ];

            // var resolutions = [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25];
            resolutions = [
                156543.03390625, 78271.516953125, 39135.7584765625, 19567.87923828125, 9783.939619140625, 4891.9698095703125, 2445.9849047851562, 1222.9924523925781, 611.4962261962891, 305.74811309814453, 152.87405654907226, 76.43702827453613,
                38.218514137268066, 19.109257068634033, 9.554628534317017, 4.777314267158508, 2.388657133579254, 1.194328566789627, 0.5971642833948135, 0.29858214169740677, 0.14929107084870338, 0.07464553542435169, 0.037322767712175846,
                0.018661383856087923, 0.009330691928043961, 0.004665345964021981, 0.0023326729820109904, 0.0011663364910054952, 5.831682455027476e-4, 2.915841227513738e-4, 1.457920613756869e-4,
            ];
            extent = [-2.003750834e7, -2.003750834e7, 2.003750834e7, 2.003750834e7];
            origin = [-2.003750834e7, 2.003750834e7];
        } else if (params.crsCode === "EPSG:5186") {
            projection = "EPSG:5186";
            matrixIds = [
                "EPSG:5186_airphoto2019:0",
                "EPSG:5186_airphoto2019:1",
                "EPSG:5186_airphoto2019:2",
                "EPSG:5186_airphoto2019:3",
                "EPSG:5186_airphoto2019:4",
                "EPSG:5186_airphoto2019:5",
                "EPSG:5186_airphoto2019:6",
                "EPSG:5186_airphoto2019:7",
                "EPSG:5186_airphoto2019:8",
                "EPSG:5186_airphoto2019:9",
                "EPSG:5186_airphoto2019:10",
                "EPSG:5186_airphoto2019:11",
                "EPSG:5186_airphoto2019:12",
            ];
            resolutions = [
                529.1677250021168, 264.5838625010584, 132.2919312505292, 66.1459656252646, 33.0729828126323, 16.933367200067735, 8.466683600033868, 4.233341800016934, 2.116670900008467, 1.0583354500042335, 0.5291677250021167, 0.2645838625010584,
                0.1322919312505292,
            ];
            //origin = [-5423200, -13609600];
            extent = [-5423200, 150556.31191262323, 285105.81661163364, 6394600];
        }

        this.wmts[layerName] = new TileLayer({
            kind: params.type,
            title: layerName,
            id: layerName,
            zIndex: params.zIndex,
            source: new WMTS({
                url: `http://${process.env.REACT_APP_GEOSERVER_HOST}/gwc/service/wmts`,
                layer: layerName,
                matrixSet: "EPSG:5186_airphoto2019",
                format: "image/jpeg",
                projection: projection,
                tileGrid: new WMTSTileGrid({
                    origin: getTopLeft(extent),
                    resolutions: resolutions,
                    matrixIds: matrixIds,
                }),
                //wrapX: true,
            }),
            visible: params.visibility,
            extent: transform([22200.99999907997, 150568.00000718067, 285105.00000044319, 322652.0000042608], "EPSG:5186", "EPSG:5181"),
            minResolution: this._getResolution(params.maxZoom),
            maxResolution: this._getResolution(params.minZoom),
            // opacity: params.opacity,
        });

        this.map.addLayer(this.wmts[layerName]);

        return this.wmts[layerName];
    };

    // Vector 레이어 추가
    addVectorLayer = (layerName, crsCode = "EPSG:5181", opacity = 1, declutter = false) => {
        this.wfs[layerName] = new VectorLayer({
            id: layerName,
            projection: crsCode,
            declutter,
            zIndex: 9999,
            source: new VectorSource({}),
        });

        this.wfs[layerName].setStyle(function (f) {
            var text = "";

            if (this.map.getView().getZoom() >= 10) {
                text = f.get("label");
            } else {
                text = "";
            }

            return [
                new olStyle.Style({
                    fill: new olStyle.Fill({
                        color: "rgba(255,255,255,0.4)",
                    }),
                    stroke: new olStyle.Stroke({
                        color: "rgba(0, 0, 255, 1)",
                        width: 2,
                    }),
                    text: new olStyle.Text({
                        font: "15px Calibri,sans-serif",
                        fill: new olStyle.Fill({
                            color: "#000",
                        }),
                        stroke: new olStyle.Stroke({
                            color: "#fff",
                            width: 2,
                        }),
                        text: text,
                        offsetX: 10,
                        offsetY: -10,
                        placement: "line",
                        overflow: true,
                    }),
                }),
            ];
        });

        this.map.addLayer(this.wfs[layerName]);

        return this.wfs[layerName];
    };

    addPointFeature = (id, geom, props = {}) => {
        geom = new Point(geom);
        let feature = new Feature({
            id: id,
            name: id,
            geometry: geom,
            ...props,
        });

        return feature;
    };

    // 포인트 피처 만들기
    createPointFeature = (geom, props = {}) => {
        geom = new Point(geom);
        let feature = new Feature({
            geometry: geom,
            ...props,
        });

        return feature;
    };

    createFeatureByWKT = (geom) => {
        let feature;

        let format = new WKT();
        feature = format.readFeature(geom);

        return feature;
    };

    createImageStyle = (imagePath) => {
        var style = new olStyle.Style({
            image: new olStyle.Icon({
                src: imagePath,
                scale: 1,
                overflow: true,
            }),
            text: new olStyle.Text({
                font: "bold 12px Nanum Gothic",
                fill: new olStyle.Fill({
                    color: "#000",
                }),
                stroke: new olStyle.Stroke({
                    color: "#fff",
                    width: 1,
                }),
                offsetX: 0,
                offsetY: -50,
            }),
        });

        return style;
    };

    createPointFeatureStyle = (size = 5, color = "#000") => {
        var style = new olStyle.Style({
            image: new olStyle.Circle({
                radius: size,
                stroke: new olStyle.Stroke({
                    color: color,
                    width: 2,
                }),
                fill: new olStyle.Fill({
                    color: color,
                }),
            }),
        });

        return style;
    };

    createPolygonFeatureStyle = (borderColor = "#000", fillColor = "rgba(255, 255, 255, 0.5)" , value) => {
        return new olStyle.Style({
            stroke: new olStyle.Stroke({
                width: 1,
                color: borderColor, // 테두리 색상 적용
            }),
            fill: new olStyle.Fill({
                color: fillColor, // 채우기 색상 적용
            }),
            text: new olStyle.Text({
                font: "bold 14px Arial",
                text: String(value.toLocaleString()), // 나이 카운트 값 표시
                fill: new olStyle.Fill({
                    color: "#000", // 라벨 색상 (검정)
                }),
                stroke: new olStyle.Stroke({
                    color: "#fff", // 테두리 (가독성을 위해 흰색)
                    width: 3,
                }),
                overflow: true, // 폴리곤 내부에 맞추기
            }),
            zIndex: 9999,
        });
    };


    // Zoom으로부터 Resolution값 가져오기
    _getResolution = (zoom) => {
        return this.map.getView().getResolutionForZoom(zoom);
    };

    // ID로 레이어 검색
    getLayerByID = (id) => {
        if (!id || !this.map) return null;
        let lyr = null;

        this.map.getLayers().forEach((item, idx) => {
            if (item.get("id") === id) lyr = item;
        });

        return lyr;
    };

    // ID로 레이어 검색
   getLayerById = (id) => {
        if (!id || !this.map) return null;
        let lyr = null;

        this.map.getLayers().forEach((item, idx) => {
            if (item.get("id") === id) lyr = item;
        });

        return lyr;
    };

    // name로 레이어 검색
    getLayerByName = (name) => {
        if (!name || !this.map) return null;
        let lyr = null;

        this.map.getLayers().forEach((item, idx) => {
            if (item.get("name") === name) lyr = item;
        });

        return lyr;
    };

    //ID로 레이어 삭제
    removeLayerById = (id) => {
        var lyr = this.getLayerByID(id);

        if (!lyr) return;
        else this.map.removeLayer(lyr);
    };

    // Wms 레이어 속성정보 가져오기
    startWmsProperty = (param) => {
        this.offClick_Wms();
        this.onClick_Wms();

        this.isEditSelect = true;
    };

    stopWmsProperty = () => {
        this.offClick_Wms();
        this.isEditSelect = false;
    };

    offClick_Wms = () => {
        this.wfs.selectLayer.getSource().clear();
        this.map.removeInteraction(this.select);
        this.map.un("click", this._onClick_Wms, this);

        this.isEditSelect = false;
    };

    onClick_Wms = () => {
        this.map.addInteraction(this.select);
        this.map.on("click", this._onClick_Wms, this);
    };

    _onClick_Wms = (evt) => {
        var self = this;
        var zoom = this.map.getView().getZoom();

        var format = new GeoJSON();
        var lyr = this.getLayerById(this.props.target);

        if (!lyr && lyr.getSource() instanceof TileWMS) return;

        var url = lyr.getSource().getGetFeatureInfoUrl(evt.coordinate, this.map.getView().getResolution(), this.map.getView().getProjection(), {
            INFO_FORMAT: "application/json",
        });

        var ajax = $.ajax({
            url: url,
            async: false,
            dataType: "json",
            success: function (response) {
                var features = format.readFeatures(response, {
                    dataProjection: self.crsCode,
                    featureProjection: self.crsCode,
                });

                if (!features) {
                    //						self.select.getFeatures().push(features[0]);

                    if (zoom < 9) {
                        self.map.getView().setZoom(9);
                        self.map.getView().setCenter(evt.coordinate);

                        return false;
                    }
                }
            },
        });

        //if (this.props.callback) {
        //	ajax.done(eval(self.props.callback));
        //}
    };

    createPointFeature = (coordinate, crsCode = "EPSG:5181") => {
        let feature;

        try {
            const geom = new Point(coordinate);
            geom.transform(crsCode, this.map.getView().getProjection().getCode());

            feature = new Feature(geom);
        } catch (ex) {
            console.log(coordinate);
        }

        return feature;
    };

    createPolylineFeature = (coordinates, crsCode = "EPSG:5181") => {
        let feature;

        const geom = new LineString(coordinates);
        geom.transform(crsCode, this.map.getView().getProjection().getCode());

        feature = new Feature(geom);

        return feature;
    };

    createFeatureByWKT = (geom, crsCode) => {
        let feature;

        let format = new WKT();
        feature = format.readFeature(geom);
        if (crsCode) {
            feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
        }

        return feature;
    };

    // createImageStyle = (data) => {
    // 	var style = new olStyle.Style({
    // 		image: new olStyle.Icon({
    // 			src: "/assets/images/map/map_ic/" + data.image + ".png",
    // 			scale: 1,
    // 		}),
    // 		text: new olStyle.Text({
    // 			font: "bold 12px Nanum Gothic",
    // 			fill: new olStyle.Fill({
    // 				color: "#000",
    // 			}),
    // 			stroke: new olStyle.Stroke({
    // 				color: "#fff",
    // 				width: 1,
    // 			}),

    // 			text: data.korName,
    // 			offsetX: 0,
    // 			offsetY: 30,
    // 		}),
    // 	});

    // 	return style;
    // };

    createPolylineFeatureStyle = (feature, lineWeight = 2, color = "#ff0000", pointSize = 50, pointColor = "#ff0000" ,lineYN = false) => {
        var geometry = feature.getGeometry();
        var type = geometry.getType();
        var styles = [];
        if (lineYN) {
            var styles = [
                new olStyle.Style({
                    stroke: new olStyle.Stroke({
                        width: lineWeight,
                        color: color,
                        lineDash: [10, 5],
                    }),
                }),
            ];
        }else{
            var styles = [
                new olStyle.Style({
                    stroke: new olStyle.Stroke({
                        width: lineWeight,
                        color: color,
                    }),
                }),
            ];
        }
        

        let idx = 0;
        if (type === "LineString") {
            geometry.forEachSegment((start, end) => {
                if (idx === 0) {
                    styles.push(
                        new olStyle.Style({
                            geometry: new Point(start),
                            image: new olStyle.Circle({
                                radius: 6,
                                fill: new olStyle.Fill({ color: "rgba(255,0,0,1)" }),
                            }),
                        })
                    );
                }

                styles.push(
                    new olStyle.Style({
                        geometry: new Point(end),
                        image: new olStyle.Circle({
                            radius: 6,
                            fill: new olStyle.Fill({ color: "rgba(255,0,0,1)" }),
                        }),
                    })
                );

                idx++;
            });
        }
        return styles;
    };

    createPointFeatureStyle = (size = 5, color = "#000") => {
        var style = new olStyle.Style({
            image: new olStyle.Circle({
                radius: size,
                stroke: new olStyle.Stroke({
                    color: color,
                    width: 2,
                }),
                fill: new olStyle.Fill({
                    color: color,
                }),
            }),
            opacity: 0,
        });

        return style;
    };


    // Wms 레이어 속성정보 가져오기
    startWmsProperty = (params) => {
        this.props = $.extend({}, this.props, params);

        this.offClick_Wms();
        this.onClick_Wms();

        this.isEditSelect = true;
    };

    stopWmsProperty = () => {
        this.offClick_Wms();
        this.isEditSelect = false;
    };

    offClick_Wms = () => {
        this.wfs.selectLayer.getSource().clear();
        this.map.removeInteraction(this.select);
        this.map.un("click", this._onClick_Wms, this);

        this.isEditSelect = false;
    };

    onClick_Wms = () => {
        //this.map.addInteraction(this.select);
        this.map.on("click", this._onClick_Wms, this);
    };

    _onClick_Wms = (evt) => {
        var self = this;
        var zoom = this.map.getView().getZoom();
        var features = [];

        if (zoom < 11) {
            alert("축척 50m 이하에서만 선택할 수 있습니다.");
            self.map.getView().setZoom(11);
            self.map.getView().setCenter(evt.coordinate);

            return false;
        }

        var name = this.props.target;
        var format = new GeoJSON();
        var lyr = this.getLayerByName(name);

        if (!lyr && lyr.getSource() instanceof TileWMS) return;

        var url = lyr.getSource().getFeatureInfoUrl(evt.coordinate, this.map.getView().getResolution(), this.map.getView().getProjection(), {
            INFO_FORMAT: "application/json",
        });

        if (!url) return;

        const arrParams = url.split("?")[1].split("&");
        const jsonData = {};

        arrParams.forEach((item, idx) => {
            if (item.indexOf("QUERY_LAYERS") > -1) {
                arrParams[idx] = "QUERY_LAYERS=" + name;
            } else if (item.indexOf("LAYERS") > -1) {
                arrParams[idx] = "LAYERS=" + name;
            }

            arrParams[idx] = arrParams[idx].replaceAll("%2C", ",").replaceAll("%3A", ":").replaceAll("%2F", "/");
            let params = arrParams[idx].split("=");

            jsonData[params[0]] = params[1];
        });

        $.ajax({
            url: "/map/proxy/wms.do",
            type: "get",
            dataType: "json",
            crossDomain: true,
            data: jsonData,
            success: function (response) {
                features = format.readFeatures(response, {
                    featureProjection: "EPSG:5186",
                });

                if (features.length > 0) {
                    if (self.props.callback) {
                        self.props.callback(features, evt);
                    }
                }
            },
        });
    };

    getPropByCoordinate = (coord, id, ansy = false, callback) => {
        var self = this;

        if (!coord || !id) return;
        if (!ansy) ansy = false;

        var map = this.map;
        var format = new GeoJSON();
        var lyr = this.getLayerByID(id);
        var feature;

        if (!lyr || !(lyr instanceof TileLayer)) {
            return;
        }

        var lyrsName = lyr.get("name");
        var url = lyr.getSource().getFeatureInfoUrl(coord, map.getView().getResolution(), map.getView().getProjection(), {
            INFO_FORMAT: "application/json",
        });

        if (!url) return;

        const arrParams = url.split("?")[1].split("&");
        const jsonData = {};

        arrParams.forEach((item, idx) => {
            if (item.indexOf("QUERY_LAYERS") > -1) {
                arrParams[idx] = "QUERY_LAYERS=" + lyrsName.toString();
            } else if (item.indexOf("LAYERS") > -1) {
                arrParams[idx] = "LAYERS=" + lyrsName.toString();
            }

            arrParams[idx] = arrParams[idx].replaceAll("%2C", ",").replaceAll("%3A", ":").replaceAll("%2F", "/");
            let params = arrParams[idx].split("=");

            jsonData[params[0]] = params[1];
        });

        jsonData["FEATURE_COUNT"] = 999;

        var ajax = $.ajax({
            url: "/map/proxy/wms.do",
            type: "get",
            dataType: "json",
            crossDomain: true,
            data: jsonData,
            async: ansy,
            success: function (response) {
                if (!response) return null;

                try {
                    var features = format.readFeatures(response, {
                        featureProjection: "EPSG:5186",
                    });

                    if (features) {
                        feature = features[0];
                    }

                    return feature;
                } catch (ex) {
                    // console.log(ex);
                    return null;
                }
            },
        });

        if (callback) {
            ajax.done(eval(callback));
        }

        return feature;
    };
}
